export enum SCREENSHOT_DATA_STATUS {
  WAITING = 'waiting',
  QUEUED = 'queued',
  IN_PROGRESS = 'in progress',
  DONE = 'done',
  FAILED = 'failed',
}
